export enum MmsTypeEnum {
    MOM = 'MOM',
    MOMNMO = 'MOMNMO',
    ROM = 'ROM'
}